import { render } from "./AppLogo.vue?vue&type=template&id=6ee4bb03"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"
script.render = render

export default script